import ScrollMagic from "scrollmagic";
import "debug.addIndicators";
const parallaxAnimation = () => {
    let w = window.innerWidth;

    const parallaxAnimationInit = () => {
        // Gestione Scene con Parallasse
        var allScene = document.querySelectorAll(".scene-parallax");
        if (allScene.length) {
            var controllerParallax = new ScrollMagic.Controller();
            allScene.forEach(function (item) {
                var elementsToAnimate =
                    item.querySelectorAll(".parallax-effect");
                if (!elementsToAnimate.length) return;
                var sceneParallax = new ScrollMagic.Scene({
                    triggerHook: "onEnter",
                    triggerElement: item,
                    duration: window.innerHeight * 1.5,
                })
                    .on("progress", function (evt) {
                        elementsToAnimate.forEach(function (element) {
                            var dataShift = element.getAttribute("data-shift");
                            var halfShift = dataShift * 0.05;

                            if (w > 1023) {
                                element.style.transform =
                                    "translateY(" +
                                    evt.progress * dataShift +
                                    "px)";
                            } else {
                                element.style.transform = "translateY(0px)";
                            }
                        });
                    })
                    // .addIndicators({name: "Indicator"})
                    .addTo(controllerParallax);
            });
        }
    };

    const pageResize = () => {
        w = window.innerWidth;
        if (w > 1023) {
            parallaxAnimationInit();
        }
    };

    parallaxAnimationInit();
    window.onresize = pageResize;
};

export { parallaxAnimation };
